import React from 'react';
import { toast } from 'react-toastify';
import LayoutDashboard from 'app/private/layout';
import { Root } from './index.styled';
import { FormStyled } from '../../../auth/containers/sign-in/index.styles';
import AppFormikInput from 'components/form/formik/input/input';
import ButtonSubmit from 'components/form/formik/button-submit';

import { EButtonType } from '../../../../components/control/button/button.types';
import { Formik } from 'formik';
import useIsEnabled2FA from '../../../../hooks/use-is-enabled-2fa';

import useGet2fa from './hooks/use-get-2fa';

import messages from '../../../../messages';
import { EMessagesAuthErrorResponseTypes } from '../../../../types/messages';
import { twoFA as types } from 'types';
import useConfirm2fa from './hooks/use-confirm-2fa';
import onAuthSuccess from '../../../../utils/on-auth-success';
import useCurrentSessionData from '../../../../hooks/use-current-session-data';

const TwoFA = () => {
  const isEnabled2FA = useIsEnabled2FA();
  const currentSessionData = useCurrentSessionData();

  const { data } = useGet2fa();
  const [mutation] = useConfirm2fa({
    onSuccess: () => {
      toast.success('Enabled 2FA successfully!');
      onAuthSuccess({userData: {...currentSessionData, ...{isEnabled2FA: true}}});
    },
    onError: (e) => {
      toast.error(
        messages.auth.onSignIn.onErrorSwitch(
          e as EMessagesAuthErrorResponseTypes,
        ),
      );
    },
  });
  return (
    <>
      <LayoutDashboard>
        <Root>
          <div style={{width: '500px'}}>
            {!isEnabled2FA && <form action="/sign-up-2fa" method="POST">
              <Formik
                validateOnChange={true}
                validateOnBlur={true}
                initialValues={{code: ''}}
                // validationSchema={signInFormValidationSchema}
                onSubmit={async (values: types.TConfirmtwoFA) => {
                  return mutation(values);
                }}
              >
                <FormStyled>
                  <div>Scan the QR Code in the Authenticator app then enter the code that you see in the app in the text field
                    and click Submit.</div>
                  <img src={data?.qrcode} className="img-fluid"/>
                  <br/>
                  <div>OR enter this code into your authentication app</div>
                  <div><b>{data?.secret}</b></div>
                  <AppFormikInput name={'code'} placeholder={'2FA Code'} />
                  <ButtonSubmit
                    wide
                    styleType={EButtonType.Primary}
                  >
                    Submit
                  </ButtonSubmit>
                </FormStyled>

              </Formik>
            </form>}
            {isEnabled2FA && (
              <div>You already enabled 2FA!</div>
            )}
          </div>
        </Root>
      </LayoutDashboard>
    </>
  );
};

export default TwoFA;
